import * as React from "react";
import { AppPortal, useTranslation } from "..";
import { Icon } from "@opendash/icons";
import { HeaderMenuItem as Menu } from "@opendash/ui";
import { Badge, Tooltip } from "antd";
export const HeaderMenuItem = React.memo(function HeaderMenuItem({ active, icon, tooltip, onClick, }) {
    const t = useTranslation();
    return (React.createElement(AppPortal, { place: "headerBeforeMenuRight" },
        React.createElement(Tooltip, { title: tooltip },
            React.createElement(Menu, { onClick: onClick, style: {
                    backgroundColor: active ? "#eee" : undefined,
                } },
                React.createElement(Badge, { dot: active },
                    React.createElement(Icon, { icon: icon, style: {
                            color: active ? "var(--ant-primary-color)" : undefined,
                        } }))))));
});
//# sourceMappingURL=HeaderMenuItem.js.map